module.exports = __webpack_public_path__ + "static/media/monster-island-adventures.b58f70b1.png";